import { css } from 'linaria';
import { styled } from 'linaria/react';

export const modalMediaCard = css`
  && {
    overflow: inherit;
    border-radius: var(--rounding-l);

    @media (--only-largeDesktop) {
      width: 978px;
    }

    @media (--only-desktop) {
      width: 768px;
    }

    @media (--only-tablet) {
      width: 544px;
    }

    @media (--only-mobile) {
      max-width: 450px;
    }

    @media (width <= 375px) {
      border-radius: unset;
    }
  }
`;

export const closeIcon = css`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;

export const modalMediaCardContent = css`
  display: flex;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    flex-direction: column;
    height: 100%;
  }

  @media (width <= 375px) {
    border-radius: unset;
  }
`;

export const ModalMediaCardFooter = styled.div`
  margin-top: auto;

  @media (--only-tablet) {
    margin-top: 32px;
  }

  @media (--only-mobile) {
    margin-top: 16px;
  }
`;

export const ModalMediaCardImage = styled.img`
  object-fit: cover;
  border-radius: 0 var(--rounding-l) var(--rounding-l) 0;

  @media (--only-largeDesktop) {
    width: 574px;
    height: 428px;
  }

  @media (--only-desktop) {
    width: 364px;
  }

  @media (--to-desktop) {
    border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  }

  @media (--only-tablet) {
    width: 544px;
    height: 340px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 200px;
  }

  @media (width <= 375px) {
    border-radius: unset;
  }
`;
